import React, { FC } from 'react'
import { FieldNames } from 'Constants/FieldNames'
import { CustomSlugIE, InterfaceElementModel } from 'Pages/interfaceElement'
import { CustomColumnIcon } from './CustomColumnIcon'
import { CustomColumnExpand } from './CustomColumnExpand'
import { CustomColumnInput } from './CustomColumnInput'
import { CustomColumnKind } from './CustomColumnKind'
import { CustomColumnRole } from './CustomColumnRole'
import { CustomColumnActions } from './CustomColumnActions'

interface ComponentProps {
	item: InterfaceElementModel
	slug: string
}

export const CustomColumns: FC<ComponentProps> = ({ item, slug }) => {
	if (!item) return null
	if (slug === CustomSlugIE.EXPAND) return <CustomColumnExpand item={item} />
	if (slug === CustomSlugIE.ICON) return <CustomColumnIcon item={item} />
	if (slug === CustomSlugIE.NAME) return <CustomColumnInput item={item} field={FieldNames.NAME} />
	if (slug === CustomSlugIE.ORDER) return <CustomColumnInput item={item} field={FieldNames.ORDER} />
	if (slug === CustomSlugIE.PARENT_ELEMENT_ID)
		return <CustomColumnInput item={item} field={FieldNames.PARENT_ELEMENT_ID} />
	if (slug === CustomSlugIE.URL) return <CustomColumnInput item={item} field={FieldNames.URL} />
	if (slug === CustomSlugIE.KIND) return <CustomColumnKind item={item} />
	if (slug === CustomSlugIE.ROLE) return <CustomColumnRole item={item} />
	if (slug === CustomSlugIE.ACTIONS) return <CustomColumnActions item={item} />
	return <>{slug}</>
}
